module.exports = __webpack_public_path__ + "static/image/service/m/kitchen@3x.jpg?779041ec";